import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

const InfoModal = ({ show, onHide, infoData }) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            backdrop="static"
            className={`modal modal-${infoData.infoBtnClass1}`} 
            keyboard={false}
        >
            <Modal.Header>
                <Modal.Title>{infoData.infoHeader}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {infoData.infoMessage}
            </Modal.Body>
            <Modal.Footer>
                <Button 
                    variant={infoData.infoBtnClass1} 
                    onClick={() => {
                        onHide(infoData.infoBtnValue1);
                    }}
                >
                    {infoData.infoBtn1}
                </Button>
                {infoData.infoBtn2 && (
                    <Button 
                        variant={infoData.infoBtnClass2} 
                        onClick={() => {
                            onHide(infoData.infoBtnValue2);
                        }}
                    >
                        {infoData.infoBtn2}
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
};

InfoModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    infoData: PropTypes.shape({
        infoHeader: PropTypes.string.isRequired,
        infoMessage: PropTypes.string.isRequired,
        infoBtn1: PropTypes.string.isRequired,
        infoBtnClass1: PropTypes.string.isRequired,
        infoBtnValue1: PropTypes.any,
        infoBtn2: PropTypes.string,
        infoBtnClass2: PropTypes.string,
        infoBtnValue2: PropTypes.any,
    }).isRequired,
};

export default InfoModal; 